import { autoinject } from "aurelia-framework";
import { transient } from "aurelia-dependency-injection";
import { NotificationClientService, NotificationType } from "../../../services/basics/notification-client.service";
import { ValidationActivation, ValidationTypeEnum } from "../../../client-validation-system/validations.models";
import { EntityValidationsService, ClientSideValidator } from "../../../client-validation-system/validations-service";
import { I18N } from 'aurelia-i18n';
import { ManageRightShipUsersClientService } from "../../../services/modules/righship-qi-manage-users.service";
import { ValidationsClientService } from "../../../services/validations/validations-client.service";
import { UrlHelper } from "../../../helpers/url-helper";

@autoinject
@transient()
export class ResetPassword {

    //userId: number;
    email: string = "";
    code: string;
    password: string = "";
    confirmPassword: string = "";
    submitting: boolean;
    validator: ClientSideValidator;

    constructor(private entityValidationsService: EntityValidationsService, private validationsClientService: ValidationsClientService,
        private notificationService: NotificationClientService, private manageRightShipUsersClientService: ManageRightShipUsersClientService,
        private i18N: I18N) {
    }

    attached() {
        const rulesHolder = {
            activation: ValidationActivation.Always,
            entityName: "ResetPassword",
            isCollection: false,
            nestedRulesHolder: [],
            rules: [
            {
                errorMessage: this.i18N.tr('password-required-text'),
                parameters: null, property: "password",
                validationType: ValidationTypeEnum.Required
            },
            {
                errorMessage: this.i18N.tr('confirm-password-required-text'),
                parameters: null, property: "confirmPassword",
                validationType: ValidationTypeEnum.Required
            },
            {
                errorMessage: this.i18N.tr('password-does-not-match-confirm-password-text'),
                parameters: JSON.stringify({
                    otherProperty: "confirmPassword",
                    property: "password",
                    operation: 0
                }), property: "password",
                validationType: ValidationTypeEnum.Compare
            }]
        };
        this.validator = this.entityValidationsService.getValidator(this, rulesHolder);        

        if (UrlHelper.getQueryStringAsObject().passwordexpired) {
            this.notificationService.show('Password has expired', 'The password for this account has now expired.', NotificationType.Error);
        }
    }

    submit() {
        this.submitting = true;
        return new Promise<void>((resolve, reject) => {
            this.validator.validate().then(validationResponse => {
                if (validationResponse.valid) {
                    this.manageRightShipUsersClientService.resetDirectPassword(this.password).then(x => {
                        if (x.validationResult && x.validationResult.hasError) {
                            this.validationsClientService.showValidationErrors(x.validationResult);
                            this.submitting = false;
                            reject();
                        }
                        else {
                            this.notificationService.show(this.i18N.tr('reset-successful-text'), this.i18N.tr('password-has-been-successfully-reset-text') + "!", NotificationType.Success);
                            
                            const referrer = UrlHelper.getReferrer() ?? '';
                            
                            location.href = referrer;
                            this.submitting = false;
                            resolve();
                        }
                    }).catch(() => {                        
                        this.submitting = false;
                        this.notificationService.show(this.i18N.tr('error-text') + "!", this.i18N.tr('password-reset-failed-text'), NotificationType.Error);
                        resolve();
                    });
                } else {
                    this.submitting = false;
                    resolve();
                }
            }).catch(() => {
                this.submitting = false;
                this.notificationService.show(this.i18N.tr('error-text') + "!", this.i18N.tr('password-reset-failed-text'), NotificationType.Error);
                resolve();
            });
        });
    }
}
